import Alpine from "alpinejs";
import focus from "@alpinejs/focus";
import collapse from "@alpinejs/collapse";
import "./Fetch";
import "./HistoryBack";
import "./LockScroll";

Alpine.plugin([focus, collapse]);

const setFullHeight = () => {
    document.documentElement.style.setProperty("--full-height", `${window.innerHeight}px`);
};

window.addEventListener("resize", setFullHeight);
setFullHeight();

export default Alpine;
